import { format } from 'date-fns';
import PropTypes from 'prop-types';

import Checkbox from '../../common/Checkbox';
import { dateInUTC } from '../../../utils/dateHelper';
import { PRODUCTS_FEEDS_DATETIME_FORMAT } from '../../../constants/dateFormats';

export function ProductsFeedProcessing({ row, isEvenClassName }) {
  return (
    <tr key={row.batch_id} className={isEvenClassName}>
      <td>
        <Checkbox value={row.batch_id} hideLabel checked={false} disabled />
      </td>
      <td>{row.batch_id}</td>
      <td>{format(dateInUTC(row.created_at), PRODUCTS_FEEDS_DATETIME_FORMAT)}</td>
      <td colSpan={5}>
        <strong>
          Job is still in progress
          <br /> No data is present yet
        </strong>
      </td>
      <td />
    </tr>
  );
}

ProductsFeedProcessing.propTypes = {
  row: PropTypes.shape({
    batch_id: PropTypes.string.isRequired,
    created_at: PropTypes.string.isRequired,
  }).isRequired,
  isEvenClassName: PropTypes.string,
};
